import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex align-items-center position-relative",
  style: {"justify-content":"space-between"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    opacity: "0.5",
    x: "17.0365",
    y: "15.1223",
    width: "8.15546",
    height: "2",
    rx: "1",
    transform: "rotate(45 17.0365 15.1223)",
    fill: "black"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z",
    fill: "black"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = {
  class: "card-toolbar w-100 w-md-unset mt-2 mb-5 mr-5",
  style: {"align-self":"flex-end"}
}
const _hoisted_6 = {
  class: "d-flex flex-column scroll-y me-n7 pe-4",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "300px",
  "data-kt-scroll-dependencies": "#user__UpdateUserModal_header",
  "data-kt-scroll-wrappers": "#user__UpdateUserModal_scroll",
  "data-kt-scroll-offset": "300px",
  style: {"height":"300px","z-index":"20 !important"}
}
const _hoisted_7 = {
  key: 0,
  class: "card card-in-modal"
}
const _hoisted_8 = { class: "card-body p-5" }
const _hoisted_9 = { class: "table align-middle table-hover table-row-bordered gy-3 mb-2" }
const _hoisted_10 = { class: "text-start text-gray-400 fw-bold text-uppercase gs-0" }
const _hoisted_11 = { style: {"min-width":"310px"} }
const _hoisted_12 = { class: "min-w-100px" }
const _hoisted_13 = { class: "text-gray-600 text-break" }
const _hoisted_14 = {
  key: 1,
  class: "d-flex justify-content-center"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VZFilter = _resolveComponent("VZFilter")!
  const _component_VZModal = _resolveComponent("VZModal")!

  return (_openBlock(), _createBlock(_component_VZModal, {
    title: `${_ctx.title}`,
    id: `${_ctx.viewName}`,
    widthClass: 'w-100 w-md-900px',
    showDialog: _ctx.showDialog,
    onModalClose: _ctx.close,
    "z-index": 100
  }, {
    actions: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
        disabled: _ctx.loading
      }, _toDisplayString(_ctx.t("common.close")), 9, _hoisted_17)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", {
          class: "svg-icon svg-icon-1 position-absolute ms-3",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
        }, _hoisted_3),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control w-md-350px ps-13",
          placeholder: _ctx.t('common.search'),
          onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args))),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchTerm) = $event))
        }, null, 40, _hoisted_4), [
          [_vModelText, _ctx.searchTerm]
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_VZFilter, {
            options: _ctx.tableFilter,
            defaultFilter: {},
            viewName: "ViewRole",
            loading: _ctx.loading,
            onFilterChange: _ctx.onFilterChange,
            ref: "VZRoleFilter"
          }, null, 8, ["options", "loading", "onFilterChange"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (!_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("table", _hoisted_9, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_10, [
                      _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.t("common.name")), 1),
                      _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.t("common.siteName")), 1)
                    ])
                  ]),
                  _createElementVNode("tbody", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.webId
                      }, [
                        _createElementVNode("td", null, _toDisplayString(item.firstName) + " " + _toDisplayString(item.lastName), 1),
                        _createElementVNode("td", null, _toDisplayString(item?.currentUserSite
                      ?.map((site) => site.siteName)
                      ?.join(", ")), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
      ])
    ]),
    _: 1
  }, 8, ["title", "id", "showDialog", "onModalClose"]))
}